// The home page.
export const home = {
    tagline: 'Audio software for electronic music artists, producers, and sound designers.',
    closed: "<strong>We're currently not open for business. Check back soon.</strong> Thank you for your interest!",
    // While there are no products to show.
    products: 'Products',
    // Beside the featured product's buttons, for signed-in users (Early Access Users activate from there).
    myLicenses: 'My licenses',
    // Under a product in Early Access (its Early Access switch, in Administration > Products).
    betaNote: "Now in Early Access with invited Early Access Users. If you're one of them, activate it from its license dialog, and see or free the computers using your license under <link>My licenses</link>.",
    // The featured product's link to its page.
    learnMore: 'Learn more',
    // Above the other products, after the featured one.
    moreProducts: 'More from Tristar'
};

export type HomeMessages = typeof home;
